import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'app-pan-image-preview-button',
  templateUrl: './pan-image-preview-button.component.html',
  styleUrl: './pan-image-preview-button.component.scss',
  standalone: false,
})
export class PanImagePreviewButtonComponent {
  public src = input.required<string>();
  public alt = input<string>('Photo');
  public modalTitle = input<string>('Photo');
  public modalTopLevel = input<boolean>(false);
  public selectedPhotoUrl = signal<string | undefined>(undefined);
}
